import './Banner.css'
import React from 'react';

function Banner(props) {

  if (props.desktopSrc && props.mobileSrc) {
    return (
        <picture>
          <source media="(min-width: 1024px)" srcSet={props.desktopSrc}/>
          <img
              src={props.mobileSrc}
              fetchpriority="high"
              width="100%"
              height="auto"
              alt="Banner"
          />
        </picture>
    );
  }

  return (
      <>
        {props.desktopSrc && (
            <img
                src={props.desktopSrc}
                className="category-desktop-banner"
                fetchpriority="high"
                width="100%"
                height="auto"
                alt="Desktop Banner"
            />
        )}

        {props.mobileSrc && (
            <img
                src={props.mobileSrc}
                className="category-mobile-banner"
                fetchpriority="high"
                width="100%"
                height="auto"
                alt="Mobile Banner"
            />
        )}
      </>
  );
}

export default Banner